// extracted by mini-css-extract-plugin
export default {"markdownImage":"Image_markdownImage__LTyTV","fieldImage":"Image_fieldImage__VzpxT","imageHoverEffect":"Image_imageHoverEffect__DK61G"};